export default __webpack_public_path__ + "static/media/ic-test-avg-time.1aa8681a.svg";